import {useEffect, useState} from "react";
import ColorSegmentList from "./ColorSegmentList";
import ColorSegmentBounds from "./ColorSegmentBounds";
import _ from "lodash";
import products from "../earth/1.0.0/products";

const ColorScaleControl = ({ earthController, menuDisplayToggle, rightMenuToggle, setRightMenuToggle, overlayType }) => {
    const [colorSegments, setColorSegments] = useState([]);
    const [colorSegmentsBounds, setColorSegmentsBounds] = useState(['','']);
    const [colorSegmentsCustom, setColorSegmentsCustom] = useState(false);
    const [colorSegmentValid, setColorSegmentValid] = useState(true);
    // const [overlayType, setOverlayType] = useState("wind");

    const handleClickColorScaleAdd = (e) => {
        let timestamp = (new Date()).getTime();
        let id = timestamp;
        let newColorSegments = _.clone(colorSegments);
        newColorSegments.push({
            id: id,
            value: 0,
            displayColorPicker: false,
            color: {
                r: 255,
                g: 255,
                b: 255,
                a: 255,
            }
        });
        setColorSegments(newColorSegments);
    }

    const handleClickColorScaleLoadDefault = (e) => {
        setColorSegmentsBounds(['','']);
        let localStorage_item_name = "settings_colorScaleBounds_" + overlayType
        localStorage.removeItem(localStorage_item_name);
        localStorage_item_name = "settings_colorScale_" + overlayType;
        localStorage.removeItem(localStorage_item_name);

        loadDefaultColorSegmentsFromProduct(overlayType);

        refreshScreen();
    }

    const handleClickColorScaleSave = (e) => {
        // valid check
        let valid = true;
        colorSegments.forEach(function (resultSegment) {
            if (isNaN(resultSegment.value) || resultSegment.value === null || resultSegment.value === undefined || resultSegment.value === "") {
                valid = false;
            }
        });
        colorSegmentsBounds.forEach((resultBound) => {
            if (isNaN(Number(resultBound))) {
                valid = false;
            }
        })


        if (!valid || !colorSegments || colorSegments.length === 0) {
            setColorSegmentValid(false);
            alert('유효하지 않은 값이 있습니다.')
            return;
        }

        // save color scale
        let selectedParameter = overlayType;
        let localStorage_item_name = "settings_colorScale_" + selectedParameter;
        let newColorSegments = [];
        colorSegments.forEach(function (resultSegment) {
            newColorSegments.push([
                parseFloat(resultSegment.value),
                [
                    resultSegment.color.r,
                    resultSegment.color.g,
                    resultSegment.color.b
                ]
            ]);
        });
        localStorage.setItem(localStorage_item_name, JSON.stringify(newColorSegments));

        // save color scale bounds
        localStorage_item_name = "settings_colorScaleBounds_" + overlayType;
        localStorage.setItem(localStorage_item_name, JSON.stringify(colorSegmentsBounds));

        setColorSegmentValid(true);
        setColorSegmentsCustom(true);

        refreshScreen();
    }

    const loadColorSegmentsBoundsFromLocalStorage = (selectedParameter) => {
        let localStorage_item_name = "settings_colorScaleBounds_" + selectedParameter;
        let local_colorSegmentsBounds = JSON.parse(localStorage.getItem(localStorage_item_name));

        if (!local_colorSegmentsBounds || (local_colorSegmentsBounds[0] === '' && local_colorSegmentsBounds[1] === '')) {
            setColorSegmentsBounds(['','']);
            return false;
        }
        if (local_colorSegmentsBounds) {
            setColorSegmentsBounds(local_colorSegmentsBounds);
            return true;
        }
    }

    const refreshScreen = () => {
        let toggleForColorScaleUpdate = earthController.configuration.get("toggleForColorScaleUpdate");
        // if (toggleForColorScaleUpdate === null) toggleForColorScaleUpdate = false;
        toggleForColorScaleUpdate = !toggleForColorScaleUpdate ? false : toggleForColorScaleUpdate;
        earthController.configuration.save({ toggleForColorScaleUpdate: !toggleForColorScaleUpdate});
    }

    const loadColorSegmentsFromLocalStorage = (selectedParameter) => {
        let localStorage_item_name = "settings_colorScale_" + selectedParameter;
        let local_colorSegments = JSON.parse(localStorage.getItem(localStorage_item_name));
        let newColorSegments = [];
        let timestamp;
        let i = 0;

        if (!local_colorSegments) {
            setColorSegments(newColorSegments);
            setColorSegmentsCustom(false);
            return false;
        }

        local_colorSegments.forEach(function (segment) {
            timestamp = (new Date()).getTime() + i++;
            newColorSegments.push({
                id: timestamp,
                value: segment[0],
                displayColorPicker: false,
                color: {
                    r: segment[1][0],
                    g: segment[1][1],
                    b: segment[1][2],
                    a: 255,
                }
            })
        });

        if (newColorSegments.length) {
            setColorSegments(newColorSegments);
            setColorSegmentsCustom(true);

            return true;
        } else {
            setColorSegmentsCustom(false);

            return false;
        }
    }

    const loadDefaultColorSegmentsFromProduct = (selectedParameter) => {
        let attr = _.clone(earthController.configuration.attributes);
        attr.overlayType = selectedParameter;
        let product = products.productsFor(attr);
        let selectedColorSegments = [];
        if (product) {
            if (product.length === 1) {
                // vector: wind
                selectedColorSegments = product[0].scale.colorSegments;
            } else { // length === 2
                // scalar
                selectedColorSegments = product[1].scale.colorSegments;
            }
        }

        if (selectedColorSegments) {
            let colorSegments = [];
            let timestamp;
            let i = 0;

            selectedColorSegments.forEach(function (segment) {
                timestamp = (new Date()).getTime() + i++;
                colorSegments.push({
                    id: timestamp,
                    value: segment[0],
                    displayColorPicker: false,
                    color: {
                        r: segment[1][0],
                        g: segment[1][1],
                        b: segment[1][2],
                        a: 255,
                    }
                })
            });

            setColorSegments(colorSegments);
            setColorSegmentsCustom(false);
        }
    }


    //최초 렌더링할때 사이드이펙트
    useEffect(() => {
        if (earthController.configuration) {
            //최초 오버레이 설정
            // const configurationOverlay = earthController.configuration.get("overlayType") === "default" ? "wind" : earthController.configuration.get("overlayType");
            // setOverlayType(configurationOverlay);

            //최초 ColorBounds 세팅
            loadColorSegmentsBoundsFromLocalStorage(overlayType);
            //최초 ColorSegment 세팅
            if (!loadColorSegmentsFromLocalStorage(overlayType)) {
                // load default;
                loadDefaultColorSegmentsFromProduct(overlayType);
            }
        } // if (earthController.configuration) { end
    }, [earthController, overlayType])

    return <div className={rightMenuToggle === 'colorScale' ? "vrt01 on":"vrt01"} style={menuDisplayToggle === true ? null : {display: 'none'}}>
        <div className="dv_close01">
            <a href="javascript:;" className="btn_close01" onClick={() => setRightMenuToggle('none')}><span className="blind">닫기</span></a>
        </div>
        <div className="dv1 cl">
            <p className="w1">색상설정</p>
            <a href="javascript:;" className="btn_plus01" onClick={handleClickColorScaleAdd}><span className="blind">추가</span></a>
        </div>
        <div className="dv2">
            <div className="dv2_in">
                    <ColorSegmentList colorSegments={colorSegments} setColorSegments={setColorSegments}></ColorSegmentList>
            </div>
        </div>
        <div className="dv3">
            <ColorSegmentBounds colorSegmentsBounds={colorSegmentsBounds} setColorSegmentsBounds={setColorSegmentsBounds}></ColorSegmentBounds>
        </div>
        <div className="dv4">
            <a href="#" className="btn_refresh01" onClick={handleClickColorScaleLoadDefault}><span className="blind">되돌리기</span></a>
            <a href="#" className="btn_save01" onClick={handleClickColorScaleSave}><span className="blind">저장</span></a>
        </div>
    </div>
}

export default ColorScaleControl;